import { FieldValues, useFormContext } from "react-hook-form";
import { ConnectFormProps } from "./ConnectForm.types";

export const ConnectForm = <TFieldValues extends FieldValues>({ children }: ConnectFormProps<TFieldValues>) => {
    const methods = useFormContext<TFieldValues>();

    return children({ ...methods });
};